import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { Injectable, EventEmitter } from '@angular/core';
import * as L from 'leaflet';
import { Subject } from 'rxjs/Subject';
import { HttpClient } from '@angular/common/http';
import { ConstantesService } from '../../../core/constantes/constantes.service';
import { Activo } from '../../../core/modelos/activo';
import { TranslateService } from '../../../../../node_modules/@ngx-translate/core';
import { ActivosService } from '../../content/activos/activos.service';

@Injectable()
export class MapaService {
    public map: L.Map;
    public baseMaps: any;
    public bounds: L.LatLngBounds;
    public limites: L.LatLngBounds;

    // Fijo los límites del mapa
    private artico = L.latLng([84.986814, -179.913355]);
    private antartico = L.latLng([-84.984656, 179.869185]);

    public indexPopup: Subject<number>;

    private hoverMarkerSource: Subject<number> = new Subject();
    hoverMarker = this.hoverMarkerSource.asObservable();

    private zoomMarkerSource: Subject<L.Marker[]> = new Subject();
    zoomMarker = this.zoomMarkerSource.asObservable();

    public popUps: L.Popup[];
    public marcadoresActivos: L.Marker[];

    constructor(
        private http: HttpClient,
        private constantes: ConstantesService,
        private translate: TranslateService,
        private activosService: ActivosService
    ) {
        this.limites = new L.LatLngBounds(this.artico, this.antartico);
        this.bounds = this.limites;
        this.indexPopup = new Subject();
        this.marcadoresActivos = new Array<L.Marker>();
    }

    getActivos(): Observable<any> {

        // return this.http.get(environment.urlBase + 'activos', this.constantes.httpOptions);
        return this.http.get(environment.urlBase + 'activosBasico', this.constantes.httpOptions);
    }

    fillBounds(markers: Array<Activo>) {
        if(!markers.length) {
          return;
        }

        // Fijo coordenadas de 2 puntos iniciales, si existen, si no, pongo el mismo 2 veces
        if (markers.length >= 2) {
            this.bounds = new L.LatLngBounds(this.formatearLatLong(markers[0]), this.formatearLatLong(markers[1]));
            if (markers.length > 2) {
                // Añado resto de coordenadas para el centrado de mapa, si hay.
                this.extendBounds(markers);
            }
        } else {
            this.bounds = new L.LatLngBounds(this.formatearLatLong(markers[0]), this.formatearLatLong(markers[0]));
        }
    }

    formatearLatLong(activo: Activo): L.LatLngExpression {
        // Metodo que recibe un activo y retorna el array con la latitud y la longitud
        return [activo.latitud, activo.longitud];
    }

    extendBounds(marcadores: any) {
        // for (let i = 2; i < marcadores.length; i++) {
        //     this.bounds.extend(marcadores[i].latLng);
        // }
        for (let i = 2; i < marcadores.length; i++) {
            this.bounds.extend(this.formatearLatLong(marcadores[i]));
        }
    }

    fitBounds() {
        this.map.fitBounds(this.bounds, {
            padding: L.point(24, 30),
            maxZoom: 15
        });
    }

    centrar(bounds: L.LatLngBounds) {
        this.map.flyToBounds(bounds, {
            padding: L.point(24, 30),
            maxZoom: 9
        });
    }

    setLimites() {
        this.map.setMaxBounds(this.limites);
    }

    addMarkers(marcadores: Array<Activo>) {

        const tipologia = this.translate.instant('MAPA.POPUP.TIPOLOGIA');
        const localizacion = this.translate.instant('MAPA.POPUP.LOCALIZACION');

        marcadores.forEach((m, index) => {
            const kpiSuperficie = m.kpis ? m.kpis.filter(kpi => kpi.clave === 1) : 0;

            const superficie = kpiSuperficie[0] ? kpiSuperficie[0].valor : '';

            const popupHTML = (activo: Activo) => `
                <div class="fuse-card">

                    <div class="card-top">
                        <img src="data:image/jpeg;base64,${activo.imagen || activo.thumbnail}" alt="">
                    </div>

                    <div class="card-bottom">
                        <div class="card-bottom--row">
                            <div><strong>${activo.nombre}</strong></div>
                            <div>${activo.tipologia.nombre}</div>
                        </div>

                        <div class="card-bottom--row">
                            <div>${activo.ciudad}</div>
                            <div>${activo.sector.nombre}</div>
                        </div>

                        <div>${activo.descripcion}</div>

                    </div>
                    </div>

                </div>
            `;

            // TENGO QUE COMENTAR ESTO PORQUE AUN NO VIENE
            // <tr>
            //     <td>Superficie</td>
            //     <td>${superficie}</td>
            // </tr>

            const popup = L.popup().setContent(popupHTML(m));

            const self = this;
            const marcador = L.marker(this.formatearLatLong(m), {
                title: m.nombre,
                alt: m.id.toString(),
                icon: L.divIcon({
                    html: '<i class="fas fa-map-marker"></i>',
                    iconAnchor: [9, 25],
                    popupAnchor: [4, -15]
                })
              })
              .bindPopup(popup, { minWidth: 350 })
              .on('popupopen', function() {

                if (!m.imagen) {
                    self.activosService.getActivoImagen(m.id).subscribe(data => {
                        const activo = marcadores.find(marcador => marcador.id === m.id)
                        
                        if (activo) {
                            activo.imagen = data.items;
                            // update popup content
                            this._popup.setContent(popupHTML(activo))
                        }
                    });
                }

                const content = this._popup._contentNode
                content.addEventListener('click', () => self.setIndexPopup(m.id))
              })
              .on('mouseover', () => this.hoverMarkerSource.next(m.id))
              .on('mouseout', () => this.hoverMarkerSource.next(undefined))
              .addTo(this.map);

            this.marcadoresActivos.push(marcador);
        });
    }

    updateMarkers(marcadores: Array<Activo>) {
        this.marcadoresActivos.forEach(marker => this.map.removeLayer(marker))
        this.marcadoresActivos = []

        this.addMarkers(marcadores)
        this.fillBounds(marcadores)
        this.fitBounds()
    }

    setIndexPopup(index: number) {
        this.indexPopup.next(index);
    }

    getIndexPopup(): Observable<any> {
        return this.indexPopup.asObservable();
    }

    destroy() {
        if (this.map) {
            this.map.remove();
        }
    }

    mapEvents() {
        this.map.on('zoom move', event => {
            const markers = this.marcadoresActivos
            const markersInZoom = markers.filter((m: L.Marker) => this.map.getBounds().contains(m.getLatLng()));

            this.zoomMarkerSource.next(markersInZoom)
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/main/components/mapa/mapa.service.ts